import { getLanguageFromStorage, triggerAnalyticsEvent, } from "syf-js-utilities";
import getCorrelationId from "./getCorrelationId";
import { DEFAULTS } from "../const/analytics";
var triggerAnalytics = function (_a) {
    var _b;
    var _c = _a.pageFunction, pageFunction = _c === void 0 ? DEFAULTS.PAGE_FUNCTION : _c, _d = _a.pageKind, pageKind = _d === void 0 ? DEFAULTS.PAGE_KIND : _d, _e = _a.pageName, pageName = _e === void 0 ? DEFAULTS.PAGE_NAME : _e, _f = _a.product, product = _f === void 0 ? DEFAULTS.PRODUCT : _f, _g = _a.pageSubFunction, pageSubFunction = _g === void 0 ? DEFAULTS.SUB_FUNCTION : _g, _h = _a.errorMessage, errorMessage = _h === void 0 ? DEFAULTS.ERROR_MESSAGE : _h, _j = _a.message, message = _j === void 0 ? DEFAULTS.MESSAGE : _j, _k = _a.messageType, messageType = _k === void 0 ? DEFAULTS.MESSAGE_TYPE : _k;
    triggerAnalyticsEvent({
        pageFunction: pageFunction,
        messageType: messageType,
        token: getCorrelationId(),
        pageName: pageName,
        pageSubFunction: pageSubFunction,
        countryLanguage: "us|".concat(getLanguageFromStorage()),
        clientName: (_b = localStorage.getItem("client")) !== null && _b !== void 0 ? _b : "",
        customerType: DEFAULTS.CUSTOMER_TYPE,
        pageKind: pageKind,
        product: product,
        errorMessage: errorMessage,
        message: message,
    });
};
export default triggerAnalytics;
